<template>
  <div class="summary-total">
    <div class="title">Sub Total</div>
    <div class="total">
      <div class="total-text">
        {{ cartStore.formattedSubtotal }}
      </div>
    </div>

    <template v-if="cartStore.discount && !cartStore.showProrate">
      <div class="title">Discount:</div>
      <div class="total">
        <div class="total-text">- {{ cartStore.formattedDiscount }}</div>
      </div>
    </template>

    <template v-if="cartStore.isShippable">
      <div class="title">Shipping</div>
      <div class="total">
        <div v-if="shippingRate" class="total-text">
          + {{ formattedShippingRate }}
        </div>
        <small v-else class="shippingText">
          Will update once shipping zip code is entered
        </small>
      </div>
    </template>

    <template v-if="paymentType === 'cc'">
      <div>
        <BaseTooltip
          tooltip-color="white"
          shadow
          arrow
          centered
          class="summary-tooltip"
        >
          <template #display>
            <div class="tooltip-reference">
              <div class="tool-tip-title title">
                <i><small>Credit card fee</small></i>
              </div>
              <div slot="reference">
                <div class="total-text-cc cc-fee">
                  <i>
                    <small class="pr-1">+ {{ formattedCreditCardFee }}</small>
                  </i>
                  <img style="margin-left: 5px" src="/images/info-gray.png" />
                </div>
              </div>
            </div>
          </template>
          <template #tooltip>
            <p>
              This is a standard 3% credit card fee. You may use your debit card
              or pay by E-Check to avoid this additional processing fee.
            </p>
          </template>
        </BaseTooltip>
      </div>
      <div style="flex-basis: 100%; height: 0"></div>
    </template>

    <template v-if="cartStore.discount && cartStore.showProrate">
      <div class="title">
        <i><small>Prorated discount:</small></i>
      </div>
      <div class="total">
        <div class="total-text">
          <i>
            <small>- {{ cartStore.formattedDiscount }}</small>
          </i>
        </div>
      </div>
    </template>

    <div class="title">Total</div>
    <div class="total">
      <div class="total-text">
        {{ formattedFinalTotal }}
      </div>
    </div>
  </div>
</template>

<script>
  import BaseTooltip from '~/components/base/BaseTooltip.vue';
  import { useCartStore } from '~/stores/cart';

  const usDollarFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  export default {
    name: 'CartSummaryComponent',
    components: { BaseTooltip },
    props: {
      isUsingCreditCard: Boolean,
      paymentType: String,
      shippingRate: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    setup() {
      const cartStore = useCartStore();
      return { cartStore };
    },
    computed: {
      creditCardFee() {
        return this.cartStore.total * 0.03;
      },
      formattedCreditCardFee() {
        if (this.isUsingCreditCard) {
          return usDollarFormatter.format(this.creditCardFee);
        } else {
          return '$0';
        }
      },
      finalTotal() {
        let total = this.cartStore.total;

        if (this.isUsingCreditCard) {
          total += this.creditCardFee;
        }

        if (this.cartStore.isShippable) {
          total += this.shippingRate;
        }

        return total;
      },
      formattedFinalTotal() {
        return usDollarFormatter.format(this.finalTotal);
      },
      formattedShippingRate() {
        return usDollarFormatter.format(this.shippingRate);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .tooltip-reference {
    display: flex;
    justify-content: space-between;
  }
  .total-text-cc {
    width: 140px;
    text-align: right;
  }
</style>
